// extracted by css-extract-rspack-plugin
export default {"default":"StatusIndicator_default__cGv3E","success":"StatusIndicator_success__rjvOR","alert":"StatusIndicator_alert__5o53a","error":"StatusIndicator_error__P4JNC"};